<template>
  <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
    <slot name="icon" />
    <div class="nav-item__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubMenuTitleV2',
  props: {
    label: {
      type: String,
      required: true,
    },
    isInnerMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
